import { BasketClient, BasketItemClient } from '@frontend/basket/api';
import { Basket, BasketItem } from '@frontend/basket/types';
import { EntityType, Rights } from '@frontend/common';
import { DetailItem, ObjectDetail } from '@frontend/components/detail';
import { ReactiveObjectList } from '@frontend/components/list-v2';
import { CommonMessage } from '@frontend/lang';

import { useBasketDetail } from './basket-detail.controller';

const ID = 'basket-detail';
export const BasketDetail = () => {
    const viewProps = useBasketDetail();

    return (
        <div id={ID}>
            <ObjectDetail<Basket>
                entityType={EntityType.BASKET}
                reactive
                fetch={(accountId: string, basketId: string) => BasketClient.fetchBasket(accountId, basketId)}
                urlParamKeys={['accountId', 'basketId']}
                baseRoute='/baskets'
                delete={{
                    onDelete: (basket) => BasketClient.deleteBasket(basket.account_id, basket.id),
                    propertyName: CommonMessage.OBJECTS.BASKET.DEFAULT,
                    displayName: (basket) => basket.id,
                    requiredPermissions: (obj) => [
                        { item: EntityType.BASKET, source: EntityType.ACCOUNT, right: Rights.DELETE, uid: obj.account_id },
                        { item: EntityType.BASKET, source: EntityType.BASKET, right: Rights.DELETE, uid: obj.id }
                    ]
                }}
                update={{
                    onUpdate: () => viewProps.navigate('../update'),
                    requiredPermissions: (obj) => [
                        { item: EntityType.BASKET, source: EntityType.ACCOUNT, right: Rights.UPDATE, uid: obj.account_id },
                        { item: EntityType.BASKET, source: EntityType.BASKET, right: Rights.UPDATE, uid: obj.id }
                    ]
                }}
                id={ID}
                objectHeader={(obj) => obj.id}
                order={['spot_id', 'status', 'user_id', 'creation_timestamp', 'update_timestamp']}>
                {(obj) => (
                    <DetailItem
                        identifier='Main'
                        main>
                        <ReactiveObjectList<BasketItem>
                            label={CommonMessage.OBJECTS.BASKET_ITEM.PLURAL}
                            fetch={(arg) => BasketItemClient.fetchBasketItems({ ...arg, basket_id: obj.id })}
                            dispatch={viewProps.dispatch}
                            type={EntityType.BASKET_ITEM}
                            columns={{
                                columns: ['product_id', 'quantity', 'spot_id', 'module_id', 'slot_id', 'creation_timestamp']
                            }}
                            tableProps={{
                                defaultHeight: true
                            }}
                        />
                    </DetailItem>
                )}
            </ObjectDetail>
        </div>
    );
};
